import React from 'react';
import {motion} from 'framer-motion';

const features=[
  {
    headerText: 'Review Page - Generate More Reviews',
    image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1781747712092-image.png',
    reverse: true,
    isMobileMockup: true,
    listItems: [
      {
        icon: '⭐',
        title: '1. Direct Customers to Any Review Platform',
        text: 'Your customers can leave reviews wherever it matters most to you — Google,Facebook,Yelp,TripAdvisor,or any directory you want more visibility on. Every button is customisable and can be added or swapped at any time.'
      },
      {
        icon: '💔',
        title: '2. Intercept Negative Feedback Before It Goes Public',
        text: 'If a customer had a less than expected experience,the widget surfaces wording to address it,and routes them directly to management — via SMS or email — so they can resolve it privately before a negative review ever gets posted.'
      },
      {
        icon: '📱',
        title: '3. Turn Your Physical Space Into a Review Magnet',
        text: 'The QR code in the top-left corner opens this same widget instantly. Print it on menus,coasters,table tents,checkout counters,and even your POS system — turning every touchpoint into an opportunity for a fresh review.'
      }
    ]
  },
  {
    headerText: 'Offers Page - Redirect them to Other Actions',
    image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1781831755760-image.png',
    reverse: false,
    isMobileMockup: true,
    listItems: [
      {
        icon: '🔥',
        title: '1. Strike While the Iron Is Hot',
        text: "After thanking them for the review,their attention is still on you. That's the perfect moment to ask them to take one more action — whether that's joining your loyalty program,following you on social,or something else entirely."
      },
      {
        icon: '👑',
        title: '2. Link Them to Your VIP Club,Menu,or Both',
        text: 'Have a VIP club signup? Link directly to it. Want to keep your food top of mind? Drop in a menu link. You can even add two buttons side-by-side so customers can do both.'
      },
      {
        icon: '📡',
        title: '3. Share the Widget Anywhere You Market',
        text: 'The widget has its own unique URL,so you can drop it into an email campaign,a text blast,or anywhere else you already reach your customers — no QR code required.'
      }
    ]
  },
  {
    headerText: 'Customized Audio Widget Included',
    reverse: true,
    isAudioSection: true,
    listItems: [
      {
        icon: '🎙️',
        title: 'Make It Personal',
        text: 'Let customers hear a friendly message directly from the restaurant owner,creating a stronger connection.'
      },
      {
        icon: '⭐',
        title: 'Generate More Reviews & Shares',
        text: 'Personally encourage customers to leave Google reviews and share your restaurant on social media.'
      },
      {
        icon: '🔊',
        title: 'Grab Customers’ Attention',
        text: 'An easy-to-use audio player lets visitors listen to your message right from your website.'
      }
    ]
  }
];

const FeatureText=({feature})=> (
  <div className="flex-1 text-left w-full">
    <h2 className="text-2xl md:text-3xl font-bold text-indigo-600 mb-8 tracking-tight">
      {feature.headerText}
    </h2>
    <div className="space-y-8">
      {feature.listItems.map((item)=> (
        <div key={item.title}>
          <h3 className="text-xl font-bold text-slate-900 mb-3 flex items-start gap-2">
            <span className="text-2xl leading-none mt-0.5">{item.icon}</span>
            <span>{item.title}</span>
          </h3>
          <p className="text-slate-600 leading-relaxed text-[15px] sm:text-base">
            {item.text}
          </p>
        </div>
      ))}
    </div>
  </div>
);

const FeatureImage=({feature})=> {
  if (feature.isAudioSection) {
    return (
      <div className="flex-1 w-full flex justify-center lg:justify-start">
        <div className="w-full max-w-md h-[360px] sm:h-[380px] flex items-center justify-center overflow-hidden rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-[0_14px_28px_rgba(15,23,42,0.12)]">
          <iframe
            src="https://emb.fouita.com/widget/0x5643dd/ft9cf73up"
            title="Restaurant audio widget"
            loading="lazy"
            className="block h-[320px] sm:h-[340px] w-full translate-y-8 border-0"
            allow="autoplay"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`flex-1 w-full flex justify-center ${feature.reverse ? 'lg:justify-start' : 'lg:justify-end'}`}>
      <div className="relative w-full max-w-[320px]">
        <div className="relative w-full aspect-[9/16] bg-slate-900 rounded-3xl shadow-2xl border-4 border-slate-800 overflow-hidden transform transition-transform hover:-translate-y-1 duration-300">
          <img src={feature.image} alt={feature.headerText} className="absolute inset-0 w-full h-full object-cover object-center" />
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] bg-brand-100/80 rounded-full blur-3xl -z-10" />
      </div>
    </div>
  );
};

const HowItWorks=()=> (
  <section className="py-20 bg-slate-50">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="space-y-24">
        {features.map((feature)=> (
          <motion.div
            key={feature.headerText}
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true,margin: '-100px'}}
            transition={{duration: 0.5}}
            className={`flex flex-col ${feature.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 lg:gap-16 xl:gap-24`}
          >
            <FeatureText feature={feature} />
            <FeatureImage feature={feature} />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;